import React from "react";
import { Box, Button, TextField } from "@mui/material";
import { Form, Formik } from "formik";
import EyeIcon from "@mui/icons-material/VisibilityOutlined";
import { courseService } from "../../../../../../services/course.service";
import { useQuery } from "@tanstack/react-query";
import { CourseMessage } from "../../../../../../types";
import useSuccessModal from "../../../../../../hooks/useSuccessModal";
import { useNavigate } from "react-router-dom";

const ConstructorStepFive = ({ course, setStep, handleOpenPreview }: any) => {
  const { showSuccessModal, SuccessModal } = useSuccessModal();
  const navigate = useNavigate();

  const { data: courseMessage } = useQuery<CourseMessage, Error>({
    queryKey: ["courseMessage", course.id],
    queryFn: () => courseService.getCourseMessage(course.id),
  });

  const initialValues = {
    welcome: courseMessage?.welcome_message || "",
    congratulation: courseMessage?.congratulation_message || "",
  };

  const handleSubmit = async (values: any) => {
    if (values.welcome && values.congratulation) {
      try {
        await courseService.putCourseMessage(
          course.id,
          values.welcome,
          values.congratulation
        );
        showSuccessModal(
          "Курс отправлен на модерацию",
          "Курс будет доступен для покупки после проверки модератором",
          () => navigate(`/panel/`)
        );
      } catch (error) {
        console.error("Ошибка при сохранении", error);
      }
    } else {
      console.log("Ошибка");
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
      }}>
      <SuccessModal />
      <Formik
        initialValues={initialValues}
        onSubmit={(values, { setSubmitting }) => {
          handleSubmit(values);
          setSubmitting(false);
        }}>
        {({ values, handleChange, handleBlur, handleSubmit }) => (
          <Form onSubmit={handleSubmit}>
            <div className="course-content">
              <div className="constructor-content-title">Сообщения курса</div>
              <div className="corse-content-description">
                Чтобы привлечь студентов к работе с материалами курса, напишите
                сообщения, которые будут автоматически отправляться им после
                регистрации на курс или его завершения. Если вы не хотите
                отправлять сообщения с приветствием или поздравлениями, оставьте
                эти текстовые поля пустыми.
              </div>

              <div className="constructor-content-title mt-52">
                Приветствие <span>обязательно</span>
              </div>
              <div className="corse-content-description">
                Сообщение для приветствия студентов перед стартом обучения.
              </div>
              <TextField
                name="welcome"
                variant="outlined"
                value={values.welcome}
                placeholder="Введите сообщение"
                inputProps={{ maxLength: 1000 }}
                onChange={handleChange}
                onBlur={handleBlur}
                sx={{
                  marginTop: "12px",
                  width: 600,
                  "@media (max-width:1000px)": {
                    width: "100%",
                  },
                }}
                className="without-label"
              />

              <div className="constructor-content-title mt-52">
                Поздравление <span>обязательно</span>
              </div>
              <div className="corse-content-description">
                Сообщения для поздравления студентов после окончания обучения.
              </div>
              <TextField
                name="congratulation"
                variant="outlined"
                value={values.congratulation}
                placeholder="Введите сообщение"
                inputProps={{ maxLength: 1000 }}
                onChange={handleChange}
                onBlur={handleBlur}
                sx={{
                  marginTop: "12px",
                  width: 600,
                  "@media (max-width:1000px)": {
                    width: "100%",
                  },
                }}
                className="without-label"
              />
            </div>

            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                backgroundColor: "#F5F8FB",
                border: "1px solid #E5E5E5",
                padding: "12px 32px 12px 32px",
                marginTop: "20px",
                "@media (max-width:1000px)": {
                  backgroundColor: "transparent",
                  border: "none",
                  width: "100%",
                  position: "unset",
                  padding: 0,
                },
              }}>
              <Box
                sx={{
                  marginLeft: "12px",
                  "@media (max-width:1000px)": {
                    margin: 0,
                    width: "48%",
                  },
                }}>
                <Button
                  variant="outlined"
                  onClick={handleOpenPreview}
                  sx={{
                    "@media (max-width:1000px)": {
                      width: "100%",
                    },
                  }}>
                  <EyeIcon sx={{ marginRight: "12px" }} /> Предпросмотр
                </Button>
                <Button
                  sx={{
                    marginLeft: "12px",
                    "@media (max-width:1000px)": {
                      margin: "10px 0 0 0",
                      width: "100%",
                    },
                  }}
                  variant="outlined"
                  onClick={() => setStep(4)}>
                  Назад
                </Button>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  gap: "12px",
                  "@media (max-width:1000px)": {
                    gap: 0,
                    width: "48%",
                  },
                }}>
                <Button
                  type="submit"
                  variant="contained"
                  sx={{
                    "@media (max-width:1000px)": {
                      width: "100%",
                    },
                  }}>
                  Отправить на модерацию
                </Button>
              </Box>
            </Box>
          </Form>
        )}
      </Formik>
    </Box>
  );
};

export default ConstructorStepFive;
